import { useState } from "react";
import {
  Box,
  TextField,
  InputAdornment,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ReleaseStageBadge from "app/components/ReleaseStageBadge";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const HelpSidebar = ({ sidebarItems, tab, setTab }) => {
  const [search, setSearch] = useState("");
  const [openDropdown, setOpenDropdown] = useState(null);

  // filter by label
  const filteredItems = sidebarItems
    .map((item) => {
      const matchesParent = item.label.toLowerCase().includes(search.toLowerCase()) || item.subKey?.toLowerCase().includes(search.toLowerCase());
      const matchingChildren =
        item.subMenus?.filter((child) =>
          child.label.toLowerCase().includes(search.toLowerCase())
        ) || [];

      if (matchesParent || matchingChildren.length > 0) {
        return {
          ...item,
          subMenus: matchesParent ? item.subMenus : matchingChildren,
        };
      }
      return null;
    })
    .filter(Boolean);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      {/* Search*/}
      <Box
        sx={{
          p: 2,
          backgroundColor: "white",
          zIndex: 1,
        }}
      >
        <TextField
          placeholder="Search"
          variant="outlined"
          size="small"
          fullWidth
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{
            backgroundColor: "#fff",
            "& .MuiOutlinedInput-root": {
              borderRadius: 5,
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: "gray" }} />
              </InputAdornment>
            ),
          }}
        />
      </Box>

      {/* Sidebar Items */}
      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          p: 2,
          "&::-webkit-scrollbar": { width: "6px" },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "rgba(0,0,0,0.3)",
            borderRadius: "10px",
          },
          scrollbarWidth: "thin",
        }}
      >
        {filteredItems.map((item) => {
          const hasChildren = search
            ? item.subMenus?.length > 0
            : item.subMenus?.length > 1;
          const isOpen =
            openDropdown === item.label ||
            (search && item.subMenus?.length > 0);

          return (
            <Box key={item.label} sx={{ mb: 1 }}>
              {/* Parent Menu */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  p: 1,
                  borderRadius: 1,
                  cursor: "pointer",
                  bgcolor: tab === item.label ? "#1976d2" : "transparent",
                  color: tab === item.label ? "white" : "black",
                  "&:hover": {
                    bgcolor: tab === item.label ? "#1976d2" : "grey.100",
                  },
                }}
                onClick={() =>
                  hasChildren
                    ? setOpenDropdown(isOpen ? null : item.label)
                    : setTab(item.label)
                }
              >
                <Box>
                  {item.subKey && (
                    <Typography
                      variant="caption"
                      sx={{
                        display: "block",
                        fontSize: "0.7rem",
                        lineHeight: 1.2,
                        opacity: 0.7,
                      }}
                    >
                      {item.subKey}
                    </Typography>
                  )}
                  <Typography variant="body2">
                    <ReleaseStageBadge stage={item.releaseStage} />
                    {item.label}
                  </Typography>
                </Box>

                {hasChildren && (
                  <ArrowDropDownIcon
                    sx={{
                      fontSize: 20,
                      transition: "transform 0.2s",
                      transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                    }}
                  />
                )}
              </Box>

              {/* Dropdown for submenus */}
              {hasChildren && isOpen && (
                <Box sx={{ ml: 2 }}>
                  {item.subMenus.map((child) => (
                    <Box
                      key={child.label}
                      onClick={() => setTab(child.label)}
                      sx={{
                        p: 1,
                        borderRadius: 1,
                        cursor: "pointer",
                        bgcolor:
                          tab === child.label ? "#1976d2" : "transparent",
                        color: tab === child.label ? "white" : "black",
                        "&:hover": {
                          bgcolor:
                            tab === child.label ? "#1976d2" : "grey.100",
                        },
                      }}
                    >
                      <ReleaseStageBadge stage={child.releaseStage} />
                      {child.label}
                    </Box>
                  ))}
                </Box>
              )}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default HelpSidebar;
